module.exports = __webpack_public_path__ + "img/stena04.a7801c4f.jpg";